import { useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Show from 'Components/Show/Show';

const StripeComponent = ({ publishableKey, children, stripePromise, setStripePromise }) => {
    useEffect(() => {
        (async () => {
            const response = await loadStripe(publishableKey);
            setStripePromise(response);
        })();
    }, [publishableKey, setStripePromise]);

    return (
        <Elements key={publishableKey} stripe={stripePromise}>
            {children}
        </Elements>
    )
}

const StripeWrapper = ({ publishableKey, children, stripePromise, setStripePromise }) => {
    return (
        <Show when={publishableKey} fallback={children}>
            <StripeComponent publishableKey={publishableKey} stripePromise={stripePromise} setStripePromise={setStripePromise}>
                {children}
            </StripeComponent>
        </Show>
    )
}

export default StripeWrapper;